export const generateCorrelationId = (): string => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2, 10);
  return `lala_${timestamp}_${random}`;
};

export const getOrCreateCorrelationId = (): string => {
  let correlationId = sessionStorage.getItem('lala_correlation_id');
  if (!correlationId) {
    correlationId = generateCorrelationId();
    sessionStorage.setItem('lala_correlation_id', correlationId);
  }
  return correlationId;
};

export const getLalaCorrelationId = (): string | null => {
  return sessionStorage.getItem('lala_correlation_id');
};
